import styled from "styled-components";

export const TeamContainer = styled.div`
  margin-bottom: 150px;
  @media screen and (max-width: 1023px) {
    margin-bottom: 55px;
  }
`;
